//import Roles from 'src/security/roles';
//import Plans from 'src/security/plans';

//const plans = Plans.values;

export default class PermissionChecker {
  currentUser

  constructor(currentUser) {
    this.currentUser = currentUser
  }

  /*get currentUserRolesIds() {
    if (!this.currentUser) {
      return []
    }
    return [Roles.values.admin]
  }*/

  match(permission): boolean {
    if (!permission) {
      return true
    }

    if (!this.currentUser) {
      return false
    }

    //We allow more than one criteria for permission. For example a permission may have a userProperty and an organization property.
    let granted = true

    if (permission.userProperty) {
      granted = granted && this.currentUser.user[`${permission.userProperty}`] === true
    }

    if (permission.organizationProperty) {
      granted = granted && this.currentUser.organization.permissions[`${permission.organizationProperty}`] === true
    }

    if (permission.userPermission) {
      granted = granted && this.currentUser.user.userPermission[`${permission.userPermission}`] === true
    }

    if (permission.checkFunction) {
      granted = granted && permission.checkFunction(this.currentUser)
    }

    return granted
  }

  /*lockedForCurrentPlan(permission) {
    if (!permission) {
      return false;
    }

    if (!this.rolesMatchOneOf(permission.allowedRoles)) {
      return false;
    }

    return !this.planMatchOneOf(permission.allowedPlans);
  }*/

  /*rolesMatchOneOf(arg) {
    if (!this.currentUserRolesIds) {
      return false;
    }

    if (!arg) {
      return false;
    }

    if (Array.isArray(arg)) {
      if (!arg.length) {
        return false;
      }

      return arg.some((role) =>
        this.currentUserRolesIds.includes(role),
      );
    }

    return this.currentUserRolesIds.includes(arg);
  }

  currentPlanMatchOneOf(plansArr) {
    if (!this.currentUser) {
      return false;
    }

    if (!plansArr) {
      return false;
    }

    if (Array.isArray(plansArr)) {
      if (!plansArr.length) {
        return false;
      }

      return plansArr.some(
        (plan) => plan === this.currentPlan,
      );
    }

    //In case the function was called with a single plan name and not an array of plans
    return plansArr === this.currentPlan;
  }

  get currentPlan() {
    if (!this.currentUser) {
      return plans.free;
    }

    if (!this.currentUser.plan) {
      return plans.free;
    }

    return this.currentUser.plan;
  }*/

  /*get currentTenantPlan() {
    if (!this.currentTenant) {
      return plans.free;
    }

    if (!this.currentTenant.plan) {
      return plans.free;
    }

    return this.currentTenant.plan;
  }*/

  /*
    get isEmptyTenant() {
      if (!this.isAuthenticated) {
        return true;
      }
  
      if (!this.currentUser.tenants) {
        return true;
      }
  
      return !this.currentUser.tenants.some(
        (tenant) => tenant.status === 'active',
      );
    }*/

  get isEmptyPermissions() {
    if (!this.isAuthenticated) {
      return true
    }
    return false
  }

  get isAuthenticated() {
    return Boolean(this.currentUser) && Boolean(this.currentUser.user) && Boolean(this.currentUser.user._id)
  }

  // get isEmailVerified() {
  //   if (!this.isAuthenticated) {
  //     return false;
  //   }

  //   return this.currentUser.emailVerified;
  // }
}
